export default class EventHandler {
  constructor({selector, attributeGroupHandler, type, alert, display, attrSelector, addToCartSelector, qtySelector}) {
    this.$container = $(selector);
    this.attributeGroupHandler = attributeGroupHandler;
    this.type = type;
    this.radio = null;
    this.select = null;
    this.colors = null;
    this.handleAlert = alert;
    this.handleDisplay = display;
    this.attrSelector = attrSelector;
    this.qtySelector = qtySelector;
    this.addToCartSelector = addToCartSelector;
    this.attach();
  }
  attach() {
    this.attributeGroupHandler.set(this.type);
    this.setEvents();
    this.resetGroups();
    this.attributeGroupHandler.setVisibleGroups();
  }
  setEvents() {
    this.setEventsForRadio();
    this.setEventsForSelect();
    this.setEventForAddToCart();
  }
  update() {
    this.detachEvents();
    this.setEvents();
    this.resetGroups();
    this.attributeGroupHandler.update();
    this.handleAlert.hide();
    if (!this.attributeGroupHandler.areAllVisibleTouched()) {
      this.handleDisplay.handle();
    }
  }
  setEventsFor16Colors() {
    const $colorSelectors = this.$container.find(this.attrSelector).find("#color_to_pick_list a");
    this.colors = $colorSelectors;
    if ($colorSelectors.length) {
      $colorSelectors.on("click.force", (e) => this.handleColorChange(e));
    }
  }
  setEventsForRadio() {
    const $radioElements = this.$container.find(this.attrSelector).find('input[type="radio"]');
    this.radio = $radioElements;
    if ($radioElements.length) {
      $radioElements.on("change.force", (e) => this.handleRadioChange(e));
    }
  }
  setEventsForSelect() {
    const $selectElements = this.$container.find(this.attrSelector).find("select");
    this.select = $selectElements;
    if ($selectElements.length) {
      $selectElements.on("change.force", (e) => this.handleSelectChange(e));
    }
  }
  resetColorsRadio() {
    this.colors && this.colors.each((i, el) => {
      const $el = $(el);
      const $colorInput = $el.closest(".attribute_list").find(".color_pick_hidden");
      const groupID = this.getGroupID($colorInput);
      const isTouched = this.attributeGroupHandler.isGroupTouched(groupID);
      if (!isTouched) {
        $el.parent("li").removeClass("selected");
      }
    });
  }
  resetRadio() {
    this.radio && this.radio.each((i, el) => {
      const $el = $(el);
      const groupID = this.getGroupID($el);
      const isTouched = this.attributeGroupHandler.isGroupTouched(groupID);
      if (!isTouched) {
        $el.removeAttr("checked");
      }
    });
  }
  resetSelect() {
    this.select && this.select.each((i, el) => {
      const $el = $(el);
      const groupID = this.getGroupID($el);
      const isTouched = this.attributeGroupHandler.isGroupTouched(groupID);
      const $oldPlaceholder = $el.find(".selectPlaceholder");
      $oldPlaceholder.length && $oldPlaceholder.remove();
      if (!isTouched) {
        const $selected = $el.find('[selected="selected"]');
        const selectedVal = $el.val();
        const $placeholderOption = $("<option>");
        const placeholderText = prestashop.forceattr.forcePlaceholder;
        const $parentUniform = $el.parent(".selector");
        if ($parentUniform.length) {
          $parentUniform.find("> span").text(placeholderText);
        }
        $placeholderOption.attr("title", placeholderText).attr("selected", true).addClass("selectPlaceholder").text(placeholderText).val(selectedVal);
        $selected.removeAttr("selected");
        $el.append($placeholderOption);
        prestashop.emit("productAttributesSelectReseted", {
          select: el,
          $appendedPlaceholder: $placeholderOption
        });
      }
    });
  }
  handleRadioChange({target}) {
    const $el = $(target);
    if ($el.is(":checked")) {
      const groupID = this.getGroupID($el);
      this.attributeGroupHandler.touchGroup(groupID);
    }
  }
  handleSelectChange({target}) {
    const $el = $(target);
    const groupID = this.getGroupID($el);
    if (!$el.attr("data-placeholder")) {
      this.attributeGroupHandler.touchGroup(groupID);
    }
  }
  handleColorChange({target}) {
    const $el = $(target);
    const $input = $el.closest(".attribute_fieldset").find(".color_pick_hidden");
    const groupID = this.getGroupID($input);
    this.attributeGroupHandler.touchGroup(groupID);
  }
  getGroupID($el) {
    return $el.attr("data-product-attribute");
  }
  resetGroups() {
    this.resetSelect();
    this.resetRadio();
    this.resetColorsRadio();
  }
  setEventForAddToCart() {
    const $btn = this.$container.find(this.addToCartSelector);
    const $qty = this.$container.find(this.qtySelector);
    $btn.on("click", (e) => {
      if (!this.attributeGroupHandler.areAllVisibleTouched()) {
        e.preventDefault();
        e.stopPropagation();
        this.handleAlert.show();
      }
    });
    $qty.on("change", (e) => {
      e.preventDefault();
      if (!this.attributeGroupHandler.areAllVisibleTouched()) {
        e.stopPropagation();
        const min = $qty.attr("min");
        $qty.val(min);
        this.handleAlert.show();
      }
    });
  }
  detachEvents() {
    this.radio && this.radio.off("change.force");
    this.select && this.select.off("change.force");
    this.colors && this.colors.off("click.force");
  }
}
